//@ts-check
/** @param {Fox} fox */
module.exports = (fox) => {
	//@ts-ignore
	const RuleBase = require('../rule')(fox);
	//@ts-ignore
	const registerMemberTplEnv = require('./common/register-member-tplenv');
	//@ts-ignore
	const registerPagerSimpleLogged = require('./common/register-pager-simple-tpls');
	//@ts-ignore
	const showGDPRForMember = require('./common/show-gdpr-popup');
	
	const { SESSION_VAR_NAME_COOKIE } = require('GDPR-popups/constants.es.js');

	return fox.extend({
		__constructor: function () {
			this.super('__constructor', arguments);

			this.originalMap = fox.clone(this.pm.rwom1('@root').getOption('map'), true);
		},

		execute: function () {
			let site = this.pm.rwom1('@root');
			let memberDl = fox.hydrateDl(this.pm.member);
			
			return this.super('execute', [site, memberDl]);
		},

		granted: function (site, memberDl) {
			var _map = {};

			registerMemberTplEnv(this, () => site.member);
			registerPagerSimpleLogged(this, true);

			if (this.wasChanged) {
				site.wom('~.Widget').forEach(function (widget) {
					widget._templaters = {};
				});
			}

			site.member = memberDl;

			fox.mergeRecursive(_map, fox.clone(this.originalMap, true), this.getParams('map'));

			site.setOption('map', _map);
			
			try {
				sessionStorage.removeItem(SESSION_VAR_NAME_COOKIE);
			} catch (e) { } finally {
				showGDPRForMember(fox);
			}
		},

		denied: function (site, memberDl) {
			if (this.wasChanged) {
				delete site.member;

				site.setOption('map', fox.clone(this.originalMap, true));
			}
		}
	}, RuleBase, null, 'Rule_Member');
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/member.es.js